import { SHOP_STATE_KEY } from '../../action-types';

export const UPDATE_SHARED_DATA = `${SHOP_STATE_KEY}/UPDATE_SHARED_DATA`;
